import { Routes } from '@angular/router';
import { Home } from './home/home';
import { Units } from './admin/units/units';
import { CategoriesType } from './admin/Categories/categories';
import { Ingredients } from './admin/ingredients/ingredients';
import { ListResipes } from './admin/list-recipes/list-recipes';
import { Resipelist } from './recipelist/recipelist';
import { EditRecipe } from './admin/edit-recipe/edit-recipe';
import { Resibe } from './recipe/recipe';
import { Login } from './login/login';
import { AuthGuard } from './guards/auth.guard';
import { NotFound } from './error-pages/not-found/not-found';
import { ListUsers } from './list-users/list-users';
import { EditUser } from './admin/edit-user/edit-user';

export const routes: Routes = [
  { path: 'login', component: Login },
  { path: 'home', component: Home, canActivate: [AuthGuard] },
  { path: 'resibelist', component: Resipelist, canActivate: [AuthGuard] },
  { path: 'resibelist/resibe/:id', component: Resibe, canActivate: [AuthGuard] },
  { path: 'units', component: Units, canActivate: [AuthGuard] },
  { path: 'categoris', component: CategoriesType, canActivate: [AuthGuard] },
  { path: 'ingredients', component: Ingredients, canActivate: [AuthGuard] },
  { path: 'recipes', component: ListResipes, canActivate: [AuthGuard] },
  { path: 'recipes/editRecipe/:id', component: EditRecipe, canActivate: [AuthGuard] },
  { path: 'users', component: ListUsers, canActivate: [AuthGuard] },
  { path: 'users/editUser/:id', component: EditUser, canActivate: [AuthGuard] },
  { path: '404', component: NotFound },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/404', pathMatch: 'full' },
];
